import { TRootState } from 'src/app/store';

const getMappings = (state: TRootState) => state.app.mappings;
export const getSourceParamsDefinitions = (state: TRootState) =>
    getMappings(state).sourceParamsDefinitions;
export const getTargetParamsDefinitions = (state: TRootState) =>
    getMappings(state).targetParamsDefinitions;
